import  { jwtServerInstance }  from '../index'
import {getTokenUser} from "@/lib/utils";
import qs from	'qs'

//参数配置列表查询接口
export const getInvestMoney = (queryFrom, pagination) => {
    return jwtServerInstance.request({
        url:'/b2cinvestmoney/query',
        method:'post',
        data:qs.stringify({
            id:queryFrom.id,
            investMoneyNumber:queryFrom.investMoneyNumber,
            payBackAccount:queryFrom.payBackAccount,
            status:queryFrom.status,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}


//参数配置列表查询接口
export const getInvestMoneyDetail = (detailId) => {
    return jwtServerInstance.request({
        url:'/b2cinvestmoney/querydetail',
        method:'post',
        data:qs.stringify({
            id:detailId
        })
    })
}

//新增一条b2c_goods数据记录
export const addInvestMoney = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cinvestmoney/add',
        method:'post',
        data:dialogForm
    })
}

//删除一条b2c_goods数据记录
export const deleteInvestMoney = (deleteId) => {
    return jwtServerInstance.request({
        url:'/b2cinvestmoney/delete',
        method:'post',
        data:qs.stringify({
            id:deleteId
        })
    })
}

//参数配置列表查询接口
export const getInvestMoneyRecords = (queryFrom, pagination) => {
    return jwtServerInstance.request({
        url:'/accountchangerecords/query',
        method:'post',
        data:qs.stringify({
            userName: queryFrom.userName,
            userType: queryFrom.userType,
            status: queryFrom.status,
            reviewUserName: queryFrom.reviewUserName,
            startTime: queryFrom.timeRange?queryFrom.timeRange[0]:null,
            endTime: queryFrom.timeRange?queryFrom.timeRange[1]:null,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

//参数配置列表查询接口
export const getAdminInvestMoneyChart = (queryFrom, pagination) => {
    return jwtServerInstance.request({
        url:'/accountchangerecords/query',
        method:'post',
        data:qs.stringify({
            serialTypeEnum: queryFrom.serialTypeEnum,
            b2cUsersId: queryFrom.b2cUsersId,
            userTypeEnum: queryFrom.userTypeEnum,
            status: queryFrom.status,
            applyDateTime: queryFrom.applyDateTime,
            startTime: queryFrom.startTime,
            endTime: queryFrom.endTime,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}


//参数配置列表查询接口
export const getAdminAccountChangeMoneyChart = (queryFrom, pagination) => {
    return jwtServerInstance.request({
        url:'/accountchangerecords/queryadminchangelog',
        method:'post',
        data:qs.stringify({
            orderId: queryFrom.orderId,
            userName: queryFrom.userName,
            taskId: queryFrom.taskId,
            serialType: queryFrom.serialType,
            userType: queryFrom.userType,
            startTime: queryFrom.timeRange?queryFrom.timeRange[0]:null,
            endTime: queryFrom.timeRange?queryFrom.timeRange[1]:null,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}


//更新shopaddress的一条数据记录
export const updateInvestMoneyRecords = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/accountchangerecords/update',
        method:'post',
        data:dialogForm
    })
}

//更新shopaddress的一条数据记录
export const updateInvestMoneyRecordsList = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/accountchangerecords/updatebatch',
        method:'post',
        data:dialogForm
    })
}

//更新shopaddress的一条数据记录
export const updateInvestMoneyProcRecordsList = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/accountchangerecords/updateprobatch',
        method:'post',
        data:dialogForm
    })
}

//参数配置列表查询接口
export const getUsersMoneyChangeRecords = (queryFrom) => {
    return jwtServerInstance.request({
        url:'/b2cinvestmoney/queryinvestmony',
        method:'post',
        data:qs.stringify({
            startTime: queryFrom.timeRange?queryFrom.timeRange[0]:null,
            endTime: queryFrom.timeRange?queryFrom.timeRange[1]:null,
        })
    })
}

//参数配置列表查询接口
export const getTotalInvestMoney = () => {
    return jwtServerInstance.request({
        url:'/b2cinvestmoney/querytotalinvestmony',
        method:'post'
    })
}

//参数配置列表查询接口
export const getTotalBalanceMoney = () => {
    return jwtServerInstance.request({
        url:'/b2cinvestmoney/querytotalmony',
        method:'post'
    })
}

//参数配置列表查询接口
export const setCashOutPassowrd = (formData) => {
    return jwtServerInstance.request({
        url:'/b2customer/resetpassword',
        method:'post',
        data: qs.stringify({
            moneyPassword:formData.cashOutPassword
        })
    })
}


//参数配置列表查询接口
export const queryNumbersWithStatus = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2cinvestmoney/querynumstatus',
        method:'post',
        data: qs.stringify({
            statusStr:queryForm.statusStr
        })
    })
}

